import {
  DataBlockListResponse,
  DataBlockResponse,
  DataFieldResponse,
  DataTemplateResponse,
  DynamicValueResponse,
} from "@/redux/datablocks/types";

export function getDataBlockFieldValue<T = DynamicValueResponse>(
  dataBlock: DataBlockResponse | DataBlockListResponse | undefined,
  fieldMapping: keyof DataBlockResponse["fieldsMapping"],
  template?: DataTemplateResponse,
  formatter?: (value: DynamicValueResponse, field: DataFieldResponse) => T,
): T | undefined {
  if (!dataBlock) return undefined;
  const field = dataBlock.fieldValues.find(
    (value) => value.field === dataBlock.fieldsMapping[fieldMapping],
  );

  if (!field) return undefined;

  if (formatter && template) {
    const templateField = template.templateFields.find(
      (tf) => tf.id === field.field,
    );

    if (!templateField) return undefined;

    return formatter(field.value as DynamicValueResponse, templateField);
  }

  return field.value as T;
}
